module.exports = __webpack_public_path__ + "media/images/square_pen_outlined-71c502772e225236050ca8d014939446.svg";